import { useEffect, useState } from "react";

const useSearchSuggestions = <T>(
  input: string,
  data: T[],
  selected: T[],
  getId: (item: T) => number,
  getLabel: (item: T) => string,
  getExtraSearchText?: (item: T) => string | null | undefined,
): { suggestions: T[]; isOpen: boolean } => {
  const [suggestions, setSuggestions] = useState<T[]>([]);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (input.length > 0) {
      const lowerInput = input.toLowerCase();
      const filtered = data.filter(
        (item) =>
          (getLabel(item).toLowerCase().includes(lowerInput) ||
            (getExtraSearchText?.(item) ?? "")
              .toLowerCase()
              .includes(lowerInput)) &&
          !selected.some((s) => getId(s) === getId(item)),
      );
      setSuggestions(filtered);
      setIsOpen(true);
    } else {
      setSuggestions([]);
      setIsOpen(false);
    }
  }, [input, selected, data, getId, getLabel, getExtraSearchText]);

  return { suggestions, isOpen };
};

export default useSearchSuggestions;
